import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';

import constant from '@/util/constant.js';
const api = {
    getProductList: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/global/productGlobal/getProductList", params, successCallback, failCallback, exceptionCallback);
    }
}

export default api;

